import {ReactNode, useContext, useEffect, useState} from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { Loading } from '../auth/components/loading'
import rootStore from '../store/RootStore'

interface PrivateRouteProps {
  returnUrl: string;
  children: ReactNode;
}

interface AuthState {
  isAuth: boolean;
  isDone: boolean;
}

const PrivateRoute = (privateRouteProps : PrivateRouteProps) : ReactNode => {
  const { returnUrl, children } = privateRouteProps
  const { signinRedirect, isAuthenticated, getUser } = useContext(AuthContext)
  const [authState, setAuthState] = useState<AuthState>({ isAuth: false, isDone: false })

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (await isAuthenticated()) {
          // Authentication is settled against the OIDC user, but AuthStore is what the app reads
          // the role from, and nothing else populates it outside the sign-in redirect callback.
          if (!rootStore.authStore.user) {
            const user = await getUser()
            if (user) rootStore.authStore.setUser(user)
          }
          setAuthState({isAuth: true, isDone: true})
        } else {
          await signinRedirect(returnUrl)
        }
      } catch (err) {
        setAuthState({isAuth: false, isDone: true})
      }
    }

    if (!authState.isDone && !authState.isAuth) {
      checkAuth()
    }
  }, [signinRedirect, isAuthenticated, getUser, returnUrl, authState])

  if (!authState.isDone) {
    return <Loading/>
  } else {
    if (authState.isAuth) {
      return <>{children}</>
    } else {
      return null
    }
  }
}

PrivateRoute.displayName = 'PrivateRoute'

export default PrivateRoute
